import { render } from "./image-and-text.vue?vue&type=template&id=7a4a3bfa&scoped=true"
import script from "./image-and-text.vue?vue&type=script&lang=js"
export * from "./image-and-text.vue?vue&type=script&lang=js"

import "./image-and-text.vue?vue&type=style&index=0&id=7a4a3bfa&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4a3bfa"]])

export default __exports__